module.exports = __webpack_public_path__ + "static/espen-39776c090eacfe2543e2eb68a68adc83.png";